/** @typedef {import("../widgets/BaseWidget").BaseWidget} BaseWidget */

/**
 * Filter widgets down to the ones that actually need a Firestore write.
 *
 * A widget needs saving when:
 *  - it has no docid yet — new widget, the document must be created;
 *  - it is dirty — a control/setting or its parent/order changed;
 *  - it was soft-deleted locally — the Deleted flag must be persisted
 *    (once persisted, useLiveReportWidgets filters it out of the editor
 *    list, so it won't be rewritten on later saves).
 *
 * Adding a reason here? mergeSnapshotWidgets must keep it across a snapshot
 * too — see the '↔ widgetsNeedingSave' test in mergeSnapshotWidgets.test.js.
 *
 * Returns the original instances (not copies) so the caller can clear
 * isDirty / assign docid on the same objects the editor holds.
 *
 * @param {BaseWidget[]} widgets
 * @returns {BaseWidget[]}
 */
const widgetsNeedingSave = (widgets) =>
    widgets.filter(widget => !widget.docid || widget.isDirty || widget.deleted);

export { widgetsNeedingSave };
